export abstract class BaseComponent extends HTMLElement {
  static readonly tagName: string;
  static readonly checkAttributes: readonly string[] = [];

  static get observedAttributes(): readonly string[] {
    return (this as typeof BaseComponent).checkAttributes;
  }

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.reader();
  }

  attributeChangedCallback(name: string, _oldValue: string, _newValue: string): void {
    const checkAttributes = (this.constructor as typeof BaseComponent).checkAttributes;
    if (checkAttributes.includes(name) && this.isConnected) {
      this.reader();
    }
  }

  protected abstract reader(): void;
}
